import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApptBookingService {

  tenantId:string="6bced242-032d-47d6-e7cb-08d8f2bf3f35";
  branchId:string="82b28344-d04e-41a0-6465-08d8f2bf3fc3";
  token:string;

  constructor(private http: HttpClient) {
   }

  getorderidpayment(data,token) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + token);
    headers = headers.append('Accept', '*/*');
    headers = headers.append('X-Host-Override', 'https://ezoviondev.azurewebsites.net');
    return this.http.post(environment.baseUrl + '/tenants/' + this.tenantId + '/tenantmst/getOrderDet/' + this.branchId, data, { headers });
  }

  verifypaymentsignature(data,token) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + token);
    headers = headers.append('Accept', '*/*');
    headers = headers.append('X-Host-Override', 'https://ezoviondev.azurewebsites.net');
    return this.http.post(environment.baseUrl + '/tenants/' + this.tenantId + '/tenantmst/verifySignature/', data, { headers });
  }

  postpatientAppointment2(data) {
    console.log('Tenent:', localStorage.getItem('tenantId'));
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + localStorage.getItem("access_token"));
    headers = headers.append('Accept', '*/*');
    headers = headers.append('X-Host-Override', 'https://ezoviondev.azurewebsites.net');
    return this.http.post(environment.baseUrl + '/patAppointment/' + this.tenantId + '/' + this.branchId + '/createPatientAppointment', data, { headers });
  }

  gettenanttemplate() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + localStorage.getItem("access_token"));
    headers = headers.append('Accept', '*/*');
    headers = headers.append('X-Host-Override', 'https://ezoviondev.azurewebsites.net');
    return this.http.get(environment.baseUrl + '/tenantSmsTemplatePurchaseMst/' + this.tenantId + '/' + this.branchId + '/TemplateDet', { headers });
  }
}
